import { TRACK_CELL_TARGETS } from "utils/config/constants";

const mapGlobalAppConfig = (config = {}) => ({
  ...config,
  appName: config.app_name,
  apiBase: config.api_base,
  authType: config.auth_type,
  authFirebase: {
    loginWithFacebook: config.auth_firebase?.login_with_facebook,
    loginWithApple: config.auth_firebase?.login_with_apple,
    loginWithGoogle: config.auth_firebase?.login_with_google,
    loginWithEmail: config.auth_firebase?.login_with_email,
    signupWithEmail: config.auth_firebase?.signup_with_email,
    separator: config.auth_firebase?.separator,
  },
  authWebUrl: config.auth_webauth_url,
  brandImage: config.brand_image,
  realmConfig: {
    realmAppId: config.realm_app,
    databaseName: config.realm_db,
  },
  paywallArtWork: config.paywall_artwork,
  theme: {
    colors: {
      primaryColor: config.primary_color,
      primaryOnColor: config.primary_on_color,
      primaryMutedColor: config.primary_muted_color,
      secondaryColor: config.secondary_color,
      secondaryOnColor: config.secondary_on_color,
      errorColor: config.error_color,
      errorOnColor: config.error_on_color,
      successColor: config.success_color,
      successOnColor: config.success_on_color,
      backdropColor: config.backdrop_color,
      backdropOnColor: config.backdrop_on_color,
      backdropMutedColor: config.backdrop_muted_color,
      surfaceColor: config.surface_color,
      surfaceOnColor: config.surface_on_color,
      surfaceMutedColor: config.surface_muted_color,
      borderColor: config.border_color,
      separatorColor: config.separator_color,
      cornerRadius: config.corner_radius,
      cornerRadiusSmall: config.corner_radius_small,
      cornerRadiusButton: config.corner_radius,
      cornerRadiusButtonSmall: config.corner_radius_small,
      readerPrimaryColor: config.reader_primary_color,
      readerSearchHighlightColor: '#fce300',
      barOnColor: config.bar_on_color,
    },
  },
  playback: {
    trackCellTarget: config.playback?.track_cell_target || TRACK_CELL_TARGETS.DETAILS,
    displayQueue: config.playback?.display_queue || true,
    displayQueueControls: config.playback?.display_queue_controls || true,
    displayTimeControls: config.playback?.display_time_controls || true,
    displayBookmarks: config.playback?.display_bookmarks || false,
    displayPlaybackRate: config.playback?.display_playback_rate || true,
  },
  onboardingPages: config.onboarding_pages,
  tabs: config.tabs.map((tab) => ({
    target: tab?.target,
    targetId: tab?.target_id,
    label: tab?.label,
    children: tab?.children?.map((subtab) => ({
      target: subtab?.target,
      targetId: subtab?.target_id,
      label: subtab?.label,
    })),
  })),
  termsLink: config.terms_link,
  privacyLink: config.privacy_link,
  locales: config.locales,
  firebaseConfig: config.firebase_config,
  overwriteTranslations: config.string_overrides,
  isAutoOpenPlayerFullScreen: config.player_auto_open ?? false,
  firebaseFunctionLocation: config.firebase_function_location,
  stripePublishableKey: config.stripe_publishable_key,
  stripePricingTableId: config.stripe_pricing_table_id,
  stripePricingTableIdPostTrial: config.stripe_pricing_table_id_post_trial,
  readerAllowPrint: config.reader_allow_print ?? true,
  readerAllowCopy: config.reader_allow_copy ?? true,
  extensions: config.extensions ?? {},
});

export default mapGlobalAppConfig;
